// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import updateSearchFields from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/UpdateSearchFields";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchFieldWrapper, {
    SearchFieldWrapperStyles,
} from "@insite/content-library/Widgets/OrderHistory/SearchFieldWrapper";
import constants from "@store/constants";
import DynamicDropdown, {
    DynamicDropdownPresentationProps,
    OptionObject,
} from "@store/MobiusOverrides/DynamicDropdown/DynamicDropdown";
import * as React from "react";
import { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => {
    return {
        locations: state.greif.components.locationFilters.locations,
        getOrdersParameter: state.pages.orderHistory.getOrdersParameter,
    };
};

const mapDispatchToProps = {
    updateSearchFields,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface OrderHistorySearchFieldLocationsStyles {
    wrapper?: SearchFieldWrapperStyles;
    locationSelectorDynamicDropdown?: DynamicDropdownPresentationProps;
}

export const showMyOrdersStyles: OrderHistorySearchFieldLocationsStyles = {};

const styles = showMyOrdersStyles;

const OrderHistorySearchFieldLocations = ({ updateSearchFields, locations, getOrdersParameter }: Props) => {
    const [options, setOptions] = useState<OptionObject[]>([]);

    const handleChange = (data?: string) => {
        updateSearchFields({ location: data });
    };

    useEffect(() => {
        const _options: OptionObject[] = locations.map(o => ({
            optionText: o.locationDescription,
            optionValue: o.location,
        }));
        setOptions(_options);
    }, [locations]);

    return (
        <SearchFieldWrapper extendedStyles={styles.wrapper}>
            <DynamicDropdown
                {...styles.locationSelectorDynamicDropdown}
                options={options}
                onSelectionChange={handleChange}
                label={translate("Greif Location")}
                placeholder={translate("Select Location")}
                selected={getOrdersParameter?.location}
            />
        </SearchFieldWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(OrderHistorySearchFieldLocations),
    definition: {
        group: "Order History",
        displayName: "Locations",
        allowedContexts: [constants.pageType.orderHistory],
    },
};

export default widgetModule;
